import { Brand, LandingPage, Location } from "@app/models";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AllowedDeliveryChannel } from "clearline-api";
import { WidgetType } from "clearline-common";

export class WidgetSettingsModalBaseComponent {
  baseWidgetType: WidgetType;
  widgetId: number;
  isCustomMapp: boolean = false;
  title: string;
  widgetSettingsJson: string;
  deliveryMethod: AllowedDeliveryChannel;
  location: Location;
  readonly = false;
  configured = false;
  useForAllLocations = false;
  page: LandingPage;
  brand: Brand;

  constructor(public activeModal: NgbActiveModal) {}

  dismiss() {
    this.activeModal.dismiss();
  }
}
